import React, { useState } from 'react';
import useTranslation from '../hooks/useTranslation';
import { updateUserProfile } from './api';

export default function UserDetailsModal({
  open,
  onClose,
  userDetails,
  setUserDetails,
  onOpenResetPassword,
}) {
  const { t, setLanguage } = useTranslation();
  const [editingProfile, setEditingProfile] = useState(false);
  const [editProfileName, setEditProfileName] = useState("");
  const [editProfileAge, setEditProfileAge] = useState("");
  const [editProfileGender, setEditProfileGender] = useState("");
  const [editProfileRole, setEditProfileRole] = useState("");
  const [editProfilePhone, setEditProfilePhone] = useState("");
  const [editProfileJobTitle, setEditProfileJobTitle] = useState("");
  const [editProfileLanguage, setEditProfileLanguage] = useState("");
  const [profileSaveError, setProfileSaveError] = useState("");
  const [profileSaveSuccess, setProfileSaveSuccess] = useState("");
  const [profileSaving, setProfileSaving] = useState(false);

  if (!open) return null;

  return (
    <div className="login-modal-bg" style={{ zIndex: 9999 }}>
      <div className="login-card" style={{ minWidth: 320, maxWidth: 420, width: '90vw', padding: '2.2rem 2rem 2.2rem 2rem', position: 'relative', background: 'var(--color-modal-bg)', color: 'var(--color-modal-text)' }}>
        <button
          type="button"
          className="login-close-btn"
          aria-label="Close User Details"
          onClick={() => { onClose(); setEditingProfile(false); setProfileSaveError(""); setProfileSaveSuccess(""); }}
          style={{ right: '1.5rem', left: 'auto', top: '1.7rem', position: 'absolute' }}
        >
          <span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 300, fontSize: '1.5em', lineHeight: 1 }}>×</span>
        </button>
        <h1 style={{ marginBottom: '0.7rem', fontSize: '2.1rem', fontWeight: 700, color: '#232323', letterSpacing: '0.5px', textAlign: 'center' }}>{t('User Details')}</h1>
        <div style={{ margin: '1.2rem 0 0.7rem 0', width: '100%' }}>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              <label style={{ width: '100%', fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', marginTop: '0.1rem', letterSpacing: '0.02em', display: 'block', textAlign: 'left' }}>{t('Name')}</label>
              {editingProfile ? (
                <input
                  type="text"
                  value={editProfileName}
                  onChange={e => setEditProfileName(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem' }}
                />
              ) : (
                <div className="user-details-value" style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem', minHeight: '2.2rem', display: 'flex', alignItems: 'center', fontWeight: 600 }}>
                  {(() => {
                    const stored = localStorage.getItem('neuro_display_name');
                    const raw = stored || (userDetails && (userDetails.display_name || userDetails.user_name)) || '';
                    if (!raw) return '-';
                    return raw.includes('@') ? raw.split('@')[0] : raw;
                  })()}
                </div>
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              <label style={{ width: '100%', fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', marginTop: '0.1rem', letterSpacing: '0.02em', display: 'block', textAlign: 'left' }}>{t('Age')}</label>
              {editingProfile ? (
                <input
                  type="number"
                  value={editProfileAge}
                  onChange={e => setEditProfileAge(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem' }}
                />
              ) : (
                <div className="user-details-value" style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem', minHeight: '2.2rem', display: 'flex', alignItems: 'center', fontWeight: 600 }}>{userDetails && userDetails.age ? userDetails.age : '-'}</div>
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              <label style={{ width: '100%', fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', marginTop: '0.1rem', letterSpacing: '0.02em', display: 'block', textAlign: 'left' }}>{t('Gender')}</label>
              {editingProfile ? (
                <select
                  value={editProfileGender}
                  onChange={e => setEditProfileGender(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem' }}
                >
                  <option value="">Select gender</option>
                  <option value="Male">{t('Male')}</option>
                  <option value="Female">{t('Female')}</option>
                  <option value="LGBTQ">{t('LGBTQ')}</option>
                  <option value="Other">{t('Other')}</option>
                </select>
              ) : (
                <div className="user-details-value" style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem', minHeight: '2.2rem', display: 'flex', alignItems: 'center', fontWeight: 600 }}>{userDetails && userDetails.gender ? t(userDetails.gender) : '-'}</div>
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              <label style={{ width: '100%', fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', marginTop: '0.1rem', letterSpacing: '0.02em', display: 'block', textAlign: 'left' }}>{t('Role')}</label>
              {editingProfile ? (
                <input
                  type="text"
                  value={editProfileRole}
                  onChange={e => setEditProfileRole(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem' }}
                />
              ) : (
                <div className="user-details-value" style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem', minHeight: '2.2rem', display: 'flex', alignItems: 'center', fontWeight: 600 }}>{userDetails && userDetails.role ? t(userDetails.role) : '-'}</div>
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              <label style={{ width: '100%', fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', marginTop: '0.1rem', letterSpacing: '0.02em', display: 'block', textAlign: 'left' }}>{t('Job Title')}</label>
              {editingProfile ? (
                <input
                  type="text"
                  value={editProfileJobTitle}
                  onChange={e => setEditProfileJobTitle(e.target.value)}
                  placeholder={t('Enter job title (optional)')}
                  style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem' }}
                />
              ) : (
                <div className="user-details-value" style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem', minHeight: '2.2rem', display: 'flex', alignItems: 'center', fontWeight: 600 }}>{userDetails && userDetails.job_title ? userDetails.job_title : '-'}</div>
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              <label style={{ width: '100%', fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', marginTop: '0.1rem', letterSpacing: '0.02em', display: 'block', textAlign: 'left' }}>{t('Phone Number')}</label>
              {editingProfile ? (
                <input
                  type="tel"
                  value={editProfilePhone}
                  onChange={e => setEditProfilePhone(e.target.value)}
                  placeholder={t('Enter phone number (optional)')}
                  style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem' }}
                />
              ) : (
                <div className="user-details-value" style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem', minHeight: '2.2rem', display: 'flex', alignItems: 'center', fontWeight: 600 }}>{userDetails && userDetails.phone ? userDetails.phone : '-'}</div>
              )}
            </div>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
              <label style={{ width: '100%', fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', marginTop: '0.1rem', letterSpacing: '0.02em', display: 'block', textAlign: 'left' }}>{t('Preferred Language')}</label>
              {editingProfile ? (
                <select
                  value={editProfileLanguage}
                  onChange={e => setEditProfileLanguage(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem' }}
                >
                  <option value="">Select language</option>
                  <option value="en">English</option>
                  <option value="de">German</option>
                  <option value="fr">French</option>
                  <option value="es">Spanish</option>
                  <option value="nl">Dutch</option>
                  <option value="pt">Portuguese</option>
                  <option value="ru">Russian</option>
                  <option value="ja">Japanese</option>
                  <option value="hi">Hindi</option>
                  <option value="ta">Tamil</option>
                  <option value="ar">Arabic</option>
                  <option value="ur">Urdu</option>
                  <option value="zh">Chinese (Mandarin)</option>
                  <option value="it">Italian</option>
                  <option value="ko">Korean</option>
                </select>
              ) : (
                <div className="user-details-value" style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', color: '#232323', fontFamily: 'inherit', marginBottom: '0.25rem', minHeight: '2.2rem', display: 'flex', alignItems: 'center', fontWeight: 600 }}>{userDetails && userDetails.preferred_language ? userDetails.preferred_language : '-'}</div>
              )}
            </div>
            {profileSaveError && <div style={{ color: '#e53935', fontSize: '0.95rem', marginBottom: 4 }}>{profileSaveError}</div>}
            {profileSaveSuccess && <div style={{ color: '#388e3c', fontSize: '0.95rem', marginBottom: 4 }}>{profileSaveSuccess}</div>}
            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
              {editingProfile ? (
                <>
                  <button
                    className="login-btn submit"
                    style={{ background: '#1976d2', color: '#fff', fontWeight: 700, flex: 1, padding: '0.7rem 0' }}
                    disabled={profileSaving}
                    onClick={async () => {
                      setProfileSaveError("");
                      setProfileSaveSuccess("");
                      setProfileSaving(true);
                      try {
                        const userIdVal = localStorage.getItem('neuro_user_id');
                        if (!userIdVal) { setProfileSaveError("User not logged in."); setProfileSaving(false); return; }
                        const updates = {};
                        if (editProfileName.trim()) updates.display_name = editProfileName.trim();
                        if (editProfileAge) updates.age = parseInt(editProfileAge, 10);
                        if (editProfileGender) updates.gender = editProfileGender;
                        if (editProfileRole.trim()) updates.role = editProfileRole.trim();
                        if (editProfilePhone.trim()) updates.phone = editProfilePhone.trim();
                        if (editProfileJobTitle.trim()) updates.job_title = editProfileJobTitle.trim();
                        if (editProfileLanguage) {
                          updates.preferred_language = editProfileLanguage;
                          setLanguage(editProfileLanguage);
                        }
                        const res = await updateUserProfile(userIdVal, updates);
                        if (res && res.status_code === 200) {
                          setProfileSaveSuccess(t('Profile updated successfully.'));
                          setEditingProfile(false);
                          if (updates.display_name) localStorage.setItem('neuro_display_name', updates.display_name);
                          setUserDetails(prev => ({ ...prev, ...updates }));
                          setTimeout(() => setProfileSaveSuccess(""), 3000);
                        } else {
                          setProfileSaveError(res?.message || t('Failed to update profile.'));
                        }
                      } catch (err) {
                        setProfileSaveError(err?.message || t('Failed to update profile.'));
                      } finally {
                        setProfileSaving(false);
                      }
                    }}
                  >
                    {profileSaving ? t('Processing...') : t('Save Changes')}
                  </button>
                  <button
                    className="login-btn submit"
                    style={{ background: '#fff', color: '#232323', border: '2px solid #ccc', fontWeight: 700, flex: 1, padding: '0.7rem 0' }}
                    onClick={() => { setEditingProfile(false); setProfileSaveError(""); }}
                  >
                    {t('Cancel')}
                  </button>
                </>
              ) : (
                <button
                  className="login-btn submit"
                  style={{ background: '#1976d2', color: '#fff', fontWeight: 700, width: '100%', padding: '0.7rem 0' }}
                  onClick={() => {
                    const stored = localStorage.getItem('neuro_display_name');
                    const raw = stored || (userDetails && (userDetails.display_name || userDetails.user_name)) || '';
                    setEditProfileName(raw.includes('@') ? raw.split('@')[0] : raw);
                    setEditProfileAge(userDetails?.age || '');
                    setEditProfileGender(userDetails?.gender || '');
                    setEditProfileRole(userDetails?.role || '');
                    setEditProfilePhone(userDetails?.phone || '');
                    setEditProfileJobTitle(userDetails?.job_title || '');
                    setEditProfileLanguage(userDetails?.preferred_language || '');
                    setEditingProfile(true);
                    setProfileSaveError("");
                    setProfileSaveSuccess("");
                  }}
                >
                  {t('Edit')}
                </button>
              )}
            </div>
            <span
              className="reset-password-link"
              style={{
                display: 'block',
                marginTop: 8,
                color: '#f49c4b',
                fontSize: '1rem',
                right: '2rem',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'color 0.2s',
                userSelect: 'none',
                marginLeft: '8.5rem',
              }}
              onClick={() => { onClose(); onOpenResetPassword(); }}
              onMouseOver={e => e.currentTarget.style.color = 'black'}
              onMouseOut={e => e.currentTarget.style.color = '#f49c4b'}
            >
              {t('Reset Password')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
